import { CSSProperties } from 'react';

interface CourseCardProps {
  title: string;
  description: string;
  lessons: number;
  duration: string;
  level: string;
  comingSoon?: boolean;
  className?: string;
  style?: CSSProperties;
}

/**
 * CourseCard Component
 *
 * Displays course information with themed styling and hover effects.
 * Shows "Coming Soon" badge for unreleased courses.
 */
export function CourseCard({
  title,
  description,
  lessons,
  duration,
  level,
  comingSoon = false,
  className = '',
  style,
}: CourseCardProps) {
  return (
    <div
      className={`landing-card landing-card--course ${comingSoon ? 'coming-soon' : ''} ${className}`}
      style={style}
    >
      {comingSoon && <span className="landing-card__badge">Coming Soon</span>}
      <h3 className="landing-card__title">{title}</h3>
      <p className="landing-card__description">{description}</p>
      <div className="landing-card__meta">
        <span>{lessons} lessons</span>
        <span>•</span>
        <span>{duration}</span>
        <span>•</span>
        <span>{level}</span>
      </div>
    </div>
  );
}
